import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function GenericBackdrop(props) {
  const classes = useStyles(props);
  return (
    <Backdrop className={classes.backdrop} open={props.open}>
      <CircularProgress data-testid="loader" color="inherit" />
    </Backdrop>
  );
}

export default GenericBackdrop;
